// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__OgEIv","label":"Radio_label__3aVyi","checkMark":"Radio_checkMark__2myYk","disabled":"Radio_disabled__2ExbB"};